import { Button } from './styles.ts';
import { useActionButtonController } from './controller/index.ts';

export function ActionButton() {
  const { onButtonClick, buttonText } = useActionButtonController();

  return <Button text={buttonText} onClick={onButtonClick} />;
}
